<template>
  <v-card v-bind="{elevation}">
    <v-img :aspect-ratio="4/3" :src="url">
      <template #placeholder>
        <v-layout fill-height align-center justify-center ma-0>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </template>
      <v-layout ma-0>
        <v-chip disabled color="white" text-color="black" small>#{{rank}}</v-chip>
        <v-spacer></v-spacer>
        <v-chip disabled color="error" text-color="white" small>{{dislikes}}</v-chip>
        <v-chip disabled color="success" text-color="white" small>{{likes}}</v-chip>
      </v-layout>
    </v-img>
  </v-card>
</template>
<script>
export default {
  name: "q-card",
  props: {
    elevation: {
      type: [Number, String],
      default: 2
    },
    url: {
      type: String
    },
    rank: {
      type: [Number, String]
    },
    likes: {
      type: [Number, String],
      default: 0
    },
    dislikes: {
      type: [Number, String],
      default: 0
    }
  }
};
</script>
